import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/faq`;

export default {
  async list() {
    let apiUrl = store.state.countrySelected.api;
    let params = {
      lang: store.state.langSelected.langWsp
    };
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
